import React from 'react';

function Packages() {
  const Packages = [
    {
      title: "Broadband",
      plans: [
        { speed: "10Mbps / 10Mbps", price: "R899.00 pm" },
        { speed: "20Mbps / 20Mbps", price: "R1199.00 pm" },
        { speed: "40Mbps / 20Mbps", price: "R1399.00 pm" },
        { speed: "50Mbps / 25Mbps", price: "R1599.00 pm" },
        { speed: "100Mbps / 50Mbps", price: "R1999.00 pm" },
        "✓ Free Installation",
        "✓ R2 500.00 router once-off"
      ]
    },
    {
      title: "Enterprise",
      plans: [
        { speed: "10Mbps / 10Mbps", price: "R1481.00 pm" },
        { speed: "20Mbps / 20Mbps", price: "R3093.24 pm" },
        { speed: "40Mbps / 20Mbps", price: "R3861.24 pm" },
        { speed: "50Mbps / 25Mbps", price: "R4134.24 pm" },
        { speed: "100Mbps / 50Mbps", price: "R5517.24 pm" },
        "✓ Free Installation",
        "✓ R2 500.00 router once-off",
        "✓ R150 pm each IP address"
      ]
    },
    {
      title: "Data Center",
      plans: [
        "✓ 43U rack space",
        "✓ 25U rack space",
        "✓ UPS & backup generator",
        "✓ 1 Gig L3 backhaul Teraco",
        "✓ 10 Gig L3 back hall Teraco"
      ]
    }
  ];

  return (
    <section className="py-5 bg-light text-center" id="Packages">
      <div className="container">
        <h2 className="text-uppercase mb-5 fw-bold" style={{ color: '#38C6C3' }}>Business Packages</h2>
        <div className="row justify-content-center">
          {Packages.map((pkg, idx) => (
            <div key={idx} className="col-md-4 mb-4">
              <div className="card shadow h-100 border-5" style={{ color: '#38C6C3', borderColor: '#0f174f' }}>
                <div className="card-body d-flex flex-column">
                  <h3 className="card-title fw-bold text-uppercase" style={{ color: '#38C6C3' }}>{pkg.title}</h3>
                  <ul className="list-unstyled text-start my-3 flex-grow-1">
                    {pkg.plans.map((item, i) => {
                      const isFirstFeature = typeof item === "string" &&
                        pkg.plans.findIndex(p => typeof p === "string") === i;

                      return typeof item === "string" ? (
                        <React.Fragment key={i}>
                          {isFirstFeature && <hr className="my-3" />} {/* Add spacing before first feature */}
                          <li className="mb-2 fw-bold">{item}</li>
                        </React.Fragment>
                      ) : (
                        <li key={i} className="mb-2 d-flex justify-content-between">
                          <span className="fw-bold">{item.speed}</span>
                          <span className="fw-bold">{item.price}</span>
                        </li>
                      );
                    })}
                  </ul>

                  <a href="#Contact" className="btn text-white mt-auto" style={{ backgroundColor: '#0f174f' }}>
                    Request a call back
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Packages;
